<template>
    <v-btn small :tile="(title || hasChildContent) && true" elevation="0" :icon="icon && (!title && !hasChildContent)" v-bind="$attrs" @click="click">
        <v-icon v-if="icon" :small="(title || hasChildContent) && true">
            mdi-{{ icon }}
        </v-icon>
        <slot>{{ title || '' }}</slot>
    </v-btn>
</template>

<script>

export default {
    name: 'Btn',
    props: {
        icon: String,
        title: String
    },
    methods: {
        click(event) {
            this.$emit('click', event);
        }
    },
    computed: {
        hasChildContent() {
            // Check if the default slot has child content
            return !!this.$slots.default;
        },
    }
}
</script>